<template>
  <el-container class="daily-sales">
    <el-header height="40px">
      <el-date-picker
        v-model="dateRange"
        type="datetimerange"
        value-format="yyyy-MM-dd HH:mm:ss"
        :picker-options="pickerOptions"
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        align="right"
        :default-time="['00:00:00', '23:59:59']"
        :editable="false"
        :clearable="false"
        :disabled="passDateRange && passDateRange.length == 2"
      />
      <el-button type="primary" icon="el-icon-refresh" @click="query">查询</el-button>
    </el-header>
    <el-main>
      <div class="chart-container">
        <div id="lineChartArea" ref="lineChartArea" style="width: 100%; height: 350px" />
      </div>
      <grid-table
        ref="gridTable"
        :tableConfig="tableConfig"
        :showIndexColumn="false"
        :showLastEmptyColumn="false"
        :showPagination="false"
        :showCheckboxColumn="false"
      >
        <template slot="TakedRate" slot-scope="{ params }"> {{ params.row.TakedRate }}% </template>
        <template slot="ReturnRate" slot-scope="{ params }"> {{ params.row.ReturnRate }}% </template>
        <template slot="Operate" slot-scope="{ params }">
          <el-link v-if="params.row.ProductID" type="primary" :underline="false" @click.native.stop="handleRowOperation(params.row)">
            查看详情
          </el-link>
        </template>
      </grid-table>
    </el-main>

    <el-drawer
      :title="'日期：' + detailView.date"
      :visible.sync="detailView.visible"
      size="85%"
      custom-class="detail-view"
      destroy-on-close
    >
      <el-tabs v-model="detailView.curTab">
        <el-tab-pane label="商品明细" name="productList">
          <producttrade-analysis :passDateRange="detailView.dateRange"></producttrade-analysis>
        </el-tab-pane>
        <el-tab-pane label="客户明细" name="customerList">
          <customer-analysis :passDateRange="detailView.dateRange"></customer-analysis>
        </el-tab-pane>
      </el-tabs>
    </el-drawer>
  </el-container>
</template>
<script>
import dayjs from 'dayjs'
import * as echarts from 'echarts'
import { submit } from '@/api/base'
import { getDatePickerOptions } from '@/utils/tool'

export default {
  name: 'deilysalesAnalysis',
  components: {
    ProducttradeAnalysis: () => import('./producttradeAnalysis.vue'),
    CustomerAnalysis: () => import('./customerAnalysis.vue'),
  },
  props: {
    productID: Number,
    purchaserID: String,
    passDateRange: Array,
  },
  beforeMount() {
    if (this.productID) {
      this.tableConfig.columns[8].isHidden = true
    }
    if (this.productID || this.purchaserID) {
      this.tableConfig.columns[12].isHidden = true
    }
    if (this.passDateRange && this.passDateRange.length == 2) {
      this.dateRange = this.passDateRange
    }
    this.queryParam.productID = this.productID || null
    this.queryParam.purchaserID = this.purchaserID || null
  },
  mounted() {
    this.$nextTick(() => {
      this.query()
    })
    // 添加窗口resize监听
    window.addEventListener('resize', this.handleResize)
  },
  data() {
    return {
      queryParam: {
        groupType: 'daily',
        startTime: '',
        endTime: '',
        productID: null,
        purchaserID: null,
      },
      dateRange: [dayjs().subtract(7, 'day').format('YYYY-MM-DD 00:00:00'), dayjs().format('YYYY-MM-DD 23:59:59')],
      pickerOptions: getDatePickerOptions(true),
      tableConfig: {
        url: '/api/dataReport/getSalesList',
        rowKey: 'Date',
        columns: [
          { label: '日期', prop: 'Date', type: 'text' },
          { label: '报单数', prop: 'Num', type: 'text', width: '130px' },
          { label: '拿货数', prop: 'TakedNum', type: 'text', width: '130px', sortType: 'custom' },
          { label: '退货数', prop: 'ReturnNum', type: 'text', width: '130px', sortType: 'custom' },
          { label: '拿货率', prop: 'TakedRate', type: 'custom-operation', width: '130px', sortType: 'custom' },
          { label: '退货率', prop: 'ReturnRate', type: 'custom-operation', width: '130px', sortType: 'custom' },
          { label: '拿货金额', prop: 'Payment', type: 'text', width: '130px', sortType: 'custom' },
          { label: '退货金额', prop: 'RefundFee', type: 'text', width: '130px', sortType: 'custom' },
          { label: '收银金额', prop: 'CashFee', type: 'text', width: '130px', sortType: 'custom' },
          { label: '拿货成本', prop: 'TakedCost', type: 'text', width: '130px' },
          { label: '退货成本', prop: 'RefundCost', type: 'text', width: '130px' },
          { label: '利润', prop: 'Profit', type: 'text', width: '130px', sortType: 'custom' },
          { label: '操作', prop: 'Operate', type: 'custom-operation', width: '130px' },
        ],
      },
      lineChartData: [],
      lineChartInstance: null,
      detailView: {
        visible: false,
        curTab: 'productList',
        date: null,
        dateRange: [],
      },
    }
  },
  methods: {
    async query() {
      this.queryParam.startTime = this.dateRange[0]
      this.queryParam.endTime = this.dateRange[1]
      this.$refs.gridTable.fetchData(
        false,
        datas => {
          this.lineChartData = datas
          this.$nextTick(() => {
            this.renderLineChart()
          })
        },
        this.queryParam,
        true
      )
    },
    renderLineChart() {
      // 销毁现有折线图
      if (this.lineChartInstance) {
        this.lineChartInstance.dispose()
      }
      if (!this.$refs.lineChartArea) return
      // 确保容器有正确的尺寸
      this.$nextTick(() => {
        // 初始化折线图
        this.lineChartInstance = echarts.init(this.$refs.lineChartArea)
        const option = this.generateLineChartOption()
        this.lineChartInstance.setOption(option)
        // 添加resize监听，在容器尺寸变化时重新调整图表
        const resizeObserver = new ResizeObserver(() => {
          if (this.lineChartInstance) {
            this.lineChartInstance.resize()
          }
        })
        resizeObserver.observe(this.$refs.lineChartArea)
      })
    },

    // 折线图配置方法
    generateLineChartOption() {
      const tableData = this.lineChartData
      // 如果没有数据，显示提示
      if (tableData.length === 0) {
        return {
          title: {
            text: '暂无数据',
            left: 'center',
            top: 'center',
            textStyle: {
              color: '#999',
              fontSize: 16,
            },
          },
          xAxis: { show: false },
          yAxis: { show: false },
          series: [],
        }
      }

      const xAxisData = []
      const numData = [] // 销售数量
      const takedNumData = [] // 拿货数量
      const returnNumData = [] // 退货数量

      tableData.forEach(item => {
        if (item.Date != '合计') {
          xAxisData.push(item.Date) // 日期
          numData.push(item.Num)
          takedNumData.push(item.TakedNum)
          returnNumData.push(item.ReturnNum)
        }
      })

      return {
        tooltip: { trigger: 'axis' },
        legend: { data: ['报单数', '拿货数', '退货数'], top: 30 },
        grid: { left: '3%', right: '4%', bottom: '3%', top: 80, containLabel: true },
        xAxis: {
          type: 'category',
          data: xAxisData,
          axisLabel: {
            rotate: 45,
            formatter: function (value) {
              return value // 直接显示已经格式化的日期
            },
          },
          name: '日期',
        },
        yAxis: { type: 'value', name: '数量' },
        series: [
          {
            name: '报单数',
            type: 'line',
            data: numData,
            itemStyle: {
              color: '#409EFF',
            },
            lineStyle: {
              color: '#409EFF',
            },
            smooth: true,
          },
          {
            name: '拿货数',
            type: 'line',
            data: takedNumData,
            itemStyle: {
              color: '#67C23A',
            },
            lineStyle: {
              color: '#67C23A',
            },
            smooth: true,
          },
          {
            name: '退货数',
            type: 'line',
            data: returnNumData,
            itemStyle: {
              color: '#F56C6C',
            },
            lineStyle: {
              color: '#F56C6C',
            },
            smooth: true,
          },
        ],
      }
    },
    handleRowOperation(row) {
      this.detailView.date = row.Date
      this.detailView.dateRange = [row.Date + ' 00:00:00', row.Date + ' 23:59:59']
      this.detailView.visible = true
    },
    beforeDestroy() {
      if (this.lineChartInstance) {
        this.lineChartInstance.dispose()
      }
      // 移除窗口resize监听
      window.removeEventListener('resize', this.handleResize)
    },
    // 处理窗口resize
    handleResize() {
      if (this.lineChartInstance) {
        this.lineChartInstance.resize()
      }
    },
  },
}
</script>

<style lang="scss">
.detail-view {
  .el-drawer__header {
    margin-bottom: 0;
    padding: 10px 10px 8px;
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }

  .el-tabs {
    padding-top: 0 !important;
  }
}
</style>

<style lang="scss" scoped>
.daily-sales {
  padding: 5px;
}

.el-button {
  margin-left: 8px;
  vertical-align: center;
}
.el-tabs {
  padding: 20px;
}
</style>
